import * as d3 from 'd3';
import * as React from 'react';

export class BackgroundComponent extends React.Component<any, any> {
    public svg: any;
    public gradient: any;
    public triangles: any = [];
    public rootRef: HTMLElement;
    public onResize$ = (window as any).siteEventSubscribers.window.resize;
    public referenceWidth = 1400;

    componentDidMount(): void {


        this.svg = d3.select(this.rootRef)
            .append('svg')
            .attr('width', this.rootRef.offsetWidth)
            .attr('height', this.rootRef.offsetHeight);

        this.gradient = this.svg.append('defs').append('linearGradient')
            .attr('id', 'backgroundGradient')
            .attr('x1', '0%')
            .attr('x2', '100%')
            .attr('y1', '100%')
            .attr('y2', '100%');

        this.gradient.append('stop')
            .attr('class', 'start')
            .attr('offset', '0%')
            .attr('stop-color', this.props.colorMatrix[0])
            .attr('stop-opacity', 1);

        this.gradient.append('stop')
            .attr('class', 'end')
            .attr('offset', '100%')
            .attr('stop-color', this.props.colorMatrix[0])
            .attr('stop-opacity', 1);

        const rect = this.svg.append('rect')
            .attr('fill', 'url(#backgroundGradient)')
            .attr('width', this.rootRef.offsetWidth)
            .attr('height', this.rootRef.offsetHeight);

        this.onResize$.subscribe(() => {
            this.svg
                .attr('width', this.rootRef.offsetWidth)
                .attr('height', this.rootRef.offsetHeight);

            rect.attr('width', this.rootRef.offsetWidth)
                .attr('height', this.rootRef.offsetHeight);

            this.svg
                .attr('width', this.rootRef.offsetWidth)
                .attr('height', this.rootRef.offsetHeight);

            this.updateTriangles(this.props.triangles);
        });
        this.setRootGradient(`linear-gradient(${this.props.colorMatrix[0]}, ${this.props.colorMatrix[1]})`);
        this.updateGradient(this.props.colorMatrix);

        // Triangles

        [0, 1, 2].forEach((item: any) => {

            const a = this.triangles[item] = this.svg.append('g')
                .attr('class', 'opacity-animation');

            if (item === 0) {
                a.attr('transform', `translate(-600, -600)`);
            }

            if (item === 1) {
                a.attr('transform', `translate(${this.rootRef.offsetWidth + 600}, -600)`);
            }

            if (item === 2) {
                a.attr('transform', `translate(-600, ${this.rootRef.offsetHeight + 600})`);
            }

            this.triangles[item].append('path')
                .attr('d', 'M 50 15, 100 100, 0 100 z')
                .attr('fill', 'red');
        });
    }

    public updateGradient(colorMatrix: any) {
        this.gradient.select('stop.start')
            .transition()
            .duration(700)
            .attr('stop-color', colorMatrix[0])
            .attr('stop-opacity', 1);

        this.gradient.select('stop.end')
            .transition()
            .duration(700)
            .attr('stop-color', colorMatrix[1])
            .attr('stop-opacity', 1);

        this.setRootGradient(`linear-gradient( to right, ${this.props.colorMatrix[0]}, ${this.props.colorMatrix[1]})`);
    }

    private setRootGradient(gradient: string) {
        const appRoot = document.getElementById('appRoot');

        if (appRoot) {
            appRoot.style.backgroundImage = gradient;
        }
    }

    public updateTriangles(triangles: any) {
        [triangles.first, triangles.second, triangles.third].forEach((T: any, index: number) => {

            if (T) {
                const centerX = T.xPercentage * this.rootRef.offsetWidth;
                const centerY = T.yPercentage * this.rootRef.offsetHeight;

                const translateX = 50 * T.scalePercentage;
                const translateY = 70 * T.scalePercentage;

                this.triangles[index]
                    .transition()
                    .duration(1000)
                    .attr('transform', `translate(${centerX}, ${centerY}), rotate(${T.rotate})`);
                this.triangles[index].select('path')
                    .transition()
                    .duration(1000)
                    .attr('fill', T.color)
                    .attr('transform', `translate(-${translateX}, -${translateY}), scale(${T.scalePercentage})`);
            }

        });

    }

    componentDidUpdate(): void {
        this.updateGradient(this.props.colorMatrix);
        this.updateTriangles(this.props.triangles);
    }

    render() {
        return <div className="backgroundComponent absolute absolute-full" ref={(ref: any) => { this.rootRef = ref; }}/>;
    }

}
